import { render } from "./legal-declaration.vue?vue&type=template&id=c135439c"
import script from "./legal-declaration.vue?vue&type=script&lang=js"
export * from "./legal-declaration.vue?vue&type=script&lang=js"

import "./legal-declaration.vue?vue&type=style&index=0&id=c135439c&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__